import { render } from "./SelectTypeComponent.vue?vue&type=template&id=0db541a4&scoped=true"
import script from "./SelectTypeComponent.vue?vue&type=script&lang=js"
export * from "./SelectTypeComponent.vue?vue&type=script&lang=js"

import "./SelectTypeComponent.vue?vue&type=style&index=0&id=0db541a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db541a4"]])

export default __exports__